import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { add } from 'date-fns';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'pt',
    interpolation: { escapeValue: false },
    resources: {
      pt: {
        translation: {
          common: {
            devices: 'DISPOSITIVOS',
            device: 'Dispositivo',
            events: 'EVENTOS',
            client: 'Cliente',
            students: 'Alunos',
            parents: 'Pais',
            IVS: 'IVS',
            LPR: 'LPR',
            description: 'Descrição',
            date: 'Data',
            time: 'Hora',
            plate: 'Placa',
            name: 'Nome',
            lastEvent: 'Último evento',
            image: 'Imagem',
            speed: 'Velocidade',
            plateImage: 'Imagem da Placa',
            carImage: 'Imagem do Carro',
            student: 'Estudante',
            responsible: 'Responsável',
            face: 'Face',
            recording: 'Gravação',
            gender: 'Gênero',
            recognitionImage: 'Imagem Reconhecida',
            actions: 'Ações',
            noItemsFound: 'Nenhum item encontrado',
            model: 'Modelo',
            brand: 'Marca',
            type: 'Tipo',
            active: 'Ativo',
            refresh: 'Atualizar',
            edit: 'Editar',
            delete: 'Excluir',
            unknown: 'Desconhecido',
            none: 'Não possui',
            notApplicable: 'Não se aplica',
            notAvailable: 'Não Possui',
            errorSaving: 'Erro ao salvar',
            errorLoadingData: 'Erro ao carregar dados',
            networkError:
              'Sem conexão com a internet. Verifique sua rede e tente novamente.',
            internalServerError: 'Erro interno do servidor!',
            databaseUnavailable: 'O serviço de banco de dados local está inacessível.',
            maxFileSizeError: 'O tamanho máximo permitido para a imagem é de 275 KB.',
          },
          monitoringPage: {
            selectDevice: 'Selecionar dispositivo',
            status: 'Status',
            online: 'Online',
            offline: 'Offline',
            loadingDevices: 'Carregando dispositivos...',
            selectDeviceHint:
              'Selecione um dispositivo para visualizar o vídeo.',
            selected: 'Selecionados',
            deviceOffline: 'Dispositivo offline',
          },
          deviceGroupPage: {
            title: 'Grupos de dispositivos',
            hint: 'Crie grupos para organizar dispositivos.',
            empty: 'Nenhum grupo cadastrado.',
            new: 'Novo grupo',
            devices: 'Dispositivos do grupo',
            devicesInGroup: 'Dispositivos no grupo',
            editGroupTitle: 'Editar grupo de dispositivos',
            newGroupTitle: 'Novo grupo de dispositivos',
            groupName: 'Nome do grupo',
            save: 'Salvar',
            confirmDelete: 'Deseja realmente excluir este grupo?',
            lock: 'Bloquear',
            unlock: 'Desbloquear',
            locked: 'Bloqueado',
            unlocked: 'Desbloqueado',
            open: 'Abrir',

          },
          dashboard: {
            welcome: 'Bem-vindo ao AlertAi',
            description:
              'Aqui você encontrará os principais indicadores da plataforma em tempo real. Navegue pelos gráficos e relatórios para acompanhar o desempenho e os eventos registrados.',
            title: 'Dashboard',
            list: 'Lista',
            defense: 'Defense',
            monitoring: 'Monitoramento',
            settings: 'Configurações',
            accountSummary: 'Resumo da conta',
            registeredDevices: 'Dispositivos cadastrados',
            activeDevices: 'Dispositivos ativos',
            faces: 'Faces gerais',
            registeredEvents: 'Eventos registrados',
            notifications: 'Notificações',
          },
          map: {
            locations: 'Localizações',
            showAll: "Mostrar todos",
            showSelected: "Mostrar apenas selecionado",
            openList: "Abrir lista de localizações",
            closeList: "Fechar lista de localizações",
            stopFollow: "Parar de seguir",
            vehicle: 'Veículo',
            latitude: 'Latitude',
            longitude: 'Longitude',
            date: 'Data/Hora',
            plate: 'Placa',
            address: 'Endereço',
            openCamera: 'Abrir câmeras',
            closeCamera: 'Fechar câmeras',
            updateTransmission: 'Atualizar transmissões',
            loadingStreams: 'Carregando transmissões ao vivo...',
            noCamerasAvailable: 'Nenhuma câmera disponível no momento...',
            cameraCollapsed: 'Exibição de câmeras recolhida.',
            liveCameras: 'Câmeras Ao Vivo',
            searchingAddress: 'Buscando endereço...',
            virtualFence: 'Cerca Virtual',
            virtualFenceDescription: 'Recebe alerta quando veículo entra ou sai da área definida.',
            status: 'Status',
            statusMonitoring: 'Monitorando',
            statusDisabled: 'Desativada',
            notificationsEnabled: 'Notificações ativadas',
            notificationPermissionDisabled: 'Permissão de notificações desativada',
            selectOrAddFence: 'Selecione ou adicione uma cerca para editar.',
            fenceName: 'Nome da cerca',
            addressOrZipCode: 'Endereço ou CEP',
            searchAddressCenter: 'Buscar centro de endereço',
            pickAddressCenter: 'Definir centro no mapa',
            pickingAddress: 'Clique no mapa para marcar o centro',
            radiusMeters: 'Raio em metros',
            empty: 'Nenhum ponto definido',
            centerMarked: 'Centro marcado',
            centerEmpty: 'Centro vazio',
            geofenceActive: 'Cerca virtual ativa',
            geofenceInactive: 'Cerca virtual inativa',
            clearCenter: 'Limpar centro',
            enteredFence: 'ENTROU na cerca',
            leftFence: 'SAIU da cerca',
            fenceListDescription: 'Abra, ajuste e monitore entrada/saída.',
            closeVirtualFence: 'Fechar cerca virtual',
            openVirtualFence: 'Abrir cerca virtual',
            delete: 'Excluir',
            cancel: 'Cancelar',
            confirmDeleteFenceTitle: 'Confirmar exclusão da cerca virtual',
            confirmDeleteFence: 'Tem certeza de que deseja excluir "{{name}}"?',
            createFenceFailed: 'Falha ao criar cerca virtual',
            updateFenceFailed: 'Falha ao atualizar cerca virtual',
            deleteFenceFailed: 'Falha ao excluir cerca virtual',
            fenceCenterDefined: 'Centro da cerca virtual definido',
            fenceCenterNotFound: 'Endereço ou CEP não encontrado',
            fence: 'Cerca {{index}}',
            fenceCenterAddressDefined: 'Centro definido por endereço/CEP',
            fenceCenterSetTo: 'Centro definido para "{{description}}"',
          },
          financial: {
            licenses: 'Licenças',
            plan: 'Plano',
            usersAmount: 'Usuários',
            devicesAmount: 'Dispositivos',
            search: 'Pesquisar Licença',
            studentsAmount: 'Alunos',
            responsiblesAmount: 'Responsáveis',
            updatedAt: 'Atualizado em',
            studentUnitValue: 'Valor por Aluno',
            totalValue: 'Valor Total',
          },
          monitoring: {
            Facial: 'Facial',
            Responsible: 'Responsável',
            Student: 'Aluno',
            dontHaveEvents: 'Não há nenhum evento.',
            eventsIVS: 'Eventos IVS',
            eventsLPR: 'Eventos LPR',
            eventsFacial: 'Eventos Faciais',
          },
          schoolMonitoring: {
            recording: 'Gravação',
            noResponsiblesAttached: 'Não há responsáveis atrelados a este aluno',
            noStudentsAttached: 'Não há alunos pertencentes a este responsável',
            videoNotFound: 'URL do vídeo não encontrada.',
            errorDownloading: 'Erro ao processar a solicitação do vídeo.',
            errorPlayingVideo: 'Não foi possível reproduzir este vídeo.',
          },
          pauseButtonComponent: {
            startUpdates: 'Iniciar Atualizações',
            pauseUpdates: 'Pausar Atualizações',
          },
          customerMonitoring: {
            birthday: 'Aniversário',
          },
          actionsOptions: {
            configuration: 'Configuração',
            viewEvents: 'Ver Eventos',
            viewRecording: 'Ver Video',
            edit: 'Editar',
            delete: 'Excluir',
          },
          actionButtonComponent: {
            edit: 'Editar',
            delete: 'Excluir',
          },
          tableComponent: {
            searchHere: 'Pesquisar aqui',
            search: 'Pesquisar',
          },
          camsPage: {
            title: 'Câmeras',
            addCam: 'Nova Câmera',
            manageGroups: 'Gerenciar Grupos',
          },
          controllersPage: {
            title: 'Controladores',
            addController: 'Novo Controlador',
          },
          routersNames: {
            dashboard: 'Dashboard',
            proposalPdf: 'Proposta PDF',
            serversPage: 'Servidores',
            monitoring: 'Monitoramento',
            geral: 'Geral',
            porter: 'Portaria',
            schoolMonitoring: 'Monitoramento Escolar',
            perimeterSchool: 'Perímetro Escolar',
            customerMonitoring: 'Clientes',
            devices: 'Dispositivos',
            cams: 'Câmeras',
            controllers: 'Controladores',
            centralAlarms: 'Centrais de Alarme',
            registerFaces: 'Faces',
            sports: 'Esportes',
            integrationsPage: 'Integrações',
            configuration: 'Configuração',
            communicationPage: 'Comunicação',
            remoteTax: 'Inspetor Remoto',
            report: 'Relatórios',
            trans: 'Transporte',
            turn: 'Turno Escolar',
            ticket: 'Ticket Escolar',
            defense: 'DefenseIA',
            management: 'Gestão',
            class: 'Turmas',
            logout: 'Sair',
            licenses: 'Licenças',
            notificationLogs: 'Logs de Notificações',
            location: 'Localização',
          },
          alarmCentral: {
            physical: 'Física',
            virtual: 'Virtual',
            editionTitle: 'Edição da central',
            type: 'Tipo de Central',
            macAddress: 'Endereço MAC',
            password: 'Senha',
            account: 'Conta',
            partitionable: 'Central Particionada',
            event: 'Evento',
            zoneUser: 'Zona/Usuário',
            partition: 'Partição',
            occurredAt: 'Aconteceu em',
            newCentral: 'Nova central',
            title: 'Centrais de alarme',
            tabCentrals: 'Centrais',
            tabEvents: 'Eventos',
            deleteTitle: 'Excluir central de alarme',
            deleteMessage:
              'Tem certeza que deseja excluir a central de alarme "{{name}}"?',
          },
          recognitionPage: {
            title: 'Faces',
            cleanFilters: 'Limpar Filtros',
            synchronization: 'Sincronização',
            newFace: 'Nova Face',
            deleteFace: 'Deletar Face',
            areYouSureWantToDeleteFace:
              'Tem certeza que deseja excluir esta face?',
            recognitionImage: 'Imagem da face',
            tableHeaders: {
              type: 'Tipo',
              name: 'Nome',
              CPF: 'CPF',
              CNPJ: 'CNPJ',
              image: 'Imagem',
              actions: 'Ações',
            },
            registerFace: {
              general: 'Geral',
              student: 'Estudante',
              responsible: 'Responsável',
              customer: 'Cliente',
              youForgotToTakeAPicture:
                'Oops! Parece que você esqueceu de registrar a imagem da face.',
              updatedFace: 'Face atualizada com sucesso!',
              registerFace: 'Face cadastrada com sucesso!',
              updatingFace: 'Face sendo atualizada...',
              registeringFace: 'Face sendo cadastrada...',
            },
            modalEditFace: {
              title: 'Edição de Face',
              name: 'Nome',
              cpf: 'CPF',
              cnpj: 'CNPJ',
              email: 'Email',
              password: 'Senha',
              faceValidity: 'Validade da Face',
              type: 'Tipo',
              employee: 'Funcionário',
              occupation: 'Ocupação',
              birthdayDate: 'Data de Nascimento',
              identification: 'Identificação',
              filterCondition: 'Condição',
              genders: {
                gender: 'Gênero',
                male: 'Masculino',
                female: 'Feminino',
                other: 'Outro',
              },
              age: 'Idade',
              editFace: 'Editar Face',
              registerFace: 'Registrar Face',
              serviceProvider: 'Prestador de Serviço',
              visitor: 'Visitante',
              faceGroup: 'Grupo de Faces',
              deviceGroup: "Grupo de dispositivos",
              facialController: 'Controlador Facial',
              shift: 'Turno',
              class: 'Turma',
              corporateUnity: 'UC (Unidade Corporativa)',
              cellPhone: 'Telefone Celular',
              addAddress: 'Adicionar endereço (opcional)',
              registration: 'Matrícula',
              dateOfBirth: 'Data de Nascimento',
              responsible: 'Responsável',
              cantLeave: 'Não pode sair?',
              schoolTransport: 'Transporte Escolar',
              editPassword: 'Editar senha',
              repeatPassword: 'Repetir senha',
              temporaryStudents: 'Alunos Temporários',
              recognitionFilter: 'Filtro de Reconhecimento',
              filter: 'Filtrar',
              filterAll: 'Todos',
              filterTemporary: 'Temporário',
              plateVehicle: 'Placa do Veículo',
              vehicleTags: 'Tag do Veículo',
              accessCardTags: 'Cartão/Tag de Acesso',
              carPlates: 'Placa do Veículo',
              status: 'Status',
              filterActive: 'Ativos',
              filterDisabled: 'Desativados',
              address: {
                address: 'Endereço',
                postalCode: 'Código Postal',
                country: 'País',
                state: 'Estado',
                city: 'Cidade',
                neighborhood: 'Bairro',
                street: 'Rua',
                addrNumber: 'Número',
                complement: 'Complemento',
              },
              buttonCaptureImage: {
                captureAgain: 'Capturar Novamente',
                save: 'Salvar',
                captureImageFace: 'Capturar Imagem da Face',
                changeFaceImage: 'Modificar Imagem da Face',
              },
              typesOfResponsible: {
                faceType: 'Tipo de Face',
                general: 'Geral',
                student: 'Estudante',
                responsible: 'Responsável',
                customer: 'Cliente',
                faceTypeNotFound: 'Tipo de face não encontrado',
                unsupportedFaceType: 'Tipo de face não suportado',
              },
            },
            syncFacesModal: {
              title: 'Sincronização de Faces',
              registeredInAlertAI: 'Registrado no AlertAI',
              noRegisteredInAlertAI: 'Não registrado no AlertAI',
              deleteController: 'Excluir controlador',
              fillInMissingData: 'Preencher dados faltantes',
              noRegisterFaces: 'Nenhuma face cadastrada no controlador.',
              facesFoundOnController: 'Faces encontradas no controlador',
            },
          },
          sportsPage: {
            sportsFacilities: 'Unidades Esportivas',
            sportsCourts: 'Quadras Esportivas',
            newUnity: 'Nova Unidade',
            unities: {
              name: 'Nome',
              state: 'Estado',
              city: 'Cidade',
              actions: 'Ações',
              sportUnityModal: {
                addTitle: 'Adicionar Unidade Esportiva',
                editTitle: 'Editar Unidade Esportiva',
                name: 'Nome',
                address: 'Endereço',
                state: 'Estado',
                city: 'Cidade',
                country: 'País',
                postalCode: 'Código Postal',
                neighborhood: 'Bairro',
                street: 'Rua',
                number: 'Número',
                complement: 'Complemento',
                saveButton: 'Salvar',
              },
            },
            blocks: {
              title: 'Blocos Esportivos',
              newBlock: 'Nova Quadra',
              name: 'Nome',
              unity: 'Unidade',
              actions: 'Ações',
              sportBlockModal: {
                addTitle: 'Adicionar Bloco Esportivo',
                editTitle: 'Editar Bloco Esportivo',
                name: 'Nome',
                unitySports: 'Unidade Esportiva',
                saveButton: 'Salvar',
                devices: 'Dispositivos',
                playbackTime: 'Tempo de Reprodução',
                playbackTimeOptions: {
                  option1: '20 segundos',
                  option2: '30 segundos',
                  option3: '40 segundos',
                },
                advertising: 'Publicidade',
              },
              sportsCourtSuccessUpdate:
                'Quadra Esportiva atualizada com sucesso!',
              sportsCourtSuccessCreate: 'Quadra Esportiva criada com sucesso!',
              imagemUploaderComponent: {
                dropImageHereOrClickToUpload:
                  'Solte a imagem aqui ou clique para enviar',
                requiredField: 'Campo obrigatório',
                invalidImageDimensions: 'Dimensões de imagem inválidas',
              },
            },
          },
          integrationsPage: {
            title: 'Integrações',
            newIntegration: 'Nova Integração',
            editIntegration: 'Editar Integração',
            typeIntegration: 'Tipo de Integração',
            tableColumns: {
              type: 'Tipo',
              name: 'Nome',
              description: 'Descrição',
              actions: 'Ações',
            },
            cigamForms: {
              name: 'Nome',
              host: 'Host',
              door: 'Porta',
              user: 'Usuário',
              password: 'Senha',
              descriptors: 'Descrição',
              active: 'Ativo',
            },
            defenseForms: {
              name: 'Nome',
              username: 'Nome de Usuário',
              ipServer: 'Ip do Servidor',
              mqttDoorServer: 'Porta MQTT do Servidor',
              userType: 'Tipo de Usuário',
              password: 'Senha',
              httpDoorServer: 'Ports HTTP do Servidor',
              description: 'Descrição',
              status: 'Status',
              save: 'Salvar',
            },
            moniForms: {
              name: 'Nome',
              door: 'Porta',
              password: 'Senha',
              enterprise: 'Empresa',
              ip: 'IP',
              user: 'Usuário',
              jointOccurrenceCode: 'Código conjunto de ocorrências',
              description: 'Descrição',
              active: 'Ativo',
              save: 'Salvar',
            },
            sigmaForms: {
              name: 'Nome',
              accountsReceivableEvents: 'Eventos de Contas a Receber',
              token: 'Token',
              description: 'Descrição',
              active: 'Ativo',
              save: 'Salvar',
            },
            surgardForms: {
              typeConnection: 'Tipo de Conexão',
              door: 'Porta',
              description: 'Descrição',
              name: 'Nome',
              intervalKeepAlive: 'Intervalo Keep Alive (Em segundos)',
              waitACK: 'Aguardar ACK',
              active: 'Ativo',
              save: 'Salvar',
            },
            webHookForms: {
              name: 'Nome',
              url: 'URL',
              token: 'Token',
              password: 'Senha',
              description: 'Descrição',
              user: 'Usuário',
              bodyRequisition: 'Corpo da Requisição',
              active: 'Ativo',
              save: 'Salvar',
            },
            defenseBridgeForms: {
              name: 'Nome',
              ipServer: 'IP do Servidor',
              doorServer: 'Porta do Servidor',
              description: 'Descrição',
              accessKey: 'Chave de Acesso',
              secretKey: 'Chave Secreta',
              status: 'Status',
              save: 'Salvar',
            },
            totvsForms: {
              name: 'Nome',
              domain: 'Domínio',
              user: 'Usuário',
              password: 'Senha',
              description: 'Descrição',
              active: 'Ativo',
              save: 'Salvar',
            },
            tuyaForms: {
              name: 'Nome',
              descriptors: 'Descrição',
              idUserTuya: 'ID de Usuário Tuya',
              status: 'Status',
              save: 'Salvar',
            },
            smtpForms: {
              host: 'Host',
              port: 'Porta',
              enableSsl: 'Habilitar SSL',
              username: 'Nome de Usuário',
              password: 'Senha',
              description: 'Descrição',
              isActive: 'Ativo',
              fromAddress: 'E-mail do Remetente',
              save: 'Salvar',
              name: 'Nome',
            },
            moovsecForms: {
              name: 'Nome',
              baseUrl: 'URL Base',
              login: 'Usuário',
              password: 'Senha',
              description: 'Descrição',
              isActive: 'Ativo',
              save: 'Salvar',
            }
          },
          defensePage: {
            deviceTable: {
              title: 'Dispositivos DefenseIA',
              synchronize: 'Sincronizar',
              columnTables: {
                status: 'Status',
                name: 'Nome',
                model: 'Modelo',
                brand: 'Marca',
                defenseID: 'ID Defense',
                actions: 'Ações',
              },
              detailsDefenseDeviceModal: {
                title: 'Detalhes do Dispositivo',
                name: 'Nome',
                model: 'Modelo',
                brand: 'Marca',
                category: 'Categoria',
                status: 'Status',
                idDefense: 'ID Defense',
                type: 'Tipo',
                ip: 'IP',
                protocol: 'Protocolo',
              },
            },
          },
          configurationPage: {
            users: {
              title: 'Usuário cadastrados',
              newUser: 'Novo usuário',
              name: 'Nome',
              email: 'Email',
              positions: 'Cargos',
              action: 'Ações',
            },
          },
          schoolShiftPage: {
            title: 'Turnos de Acesso',
            searchPlaceholder: 'Procurar turno...',
            clearSearch: 'Limpar busca',
            newShift: 'Cadastrar novo turno',
            noShiftFound: 'Nenhum turno encontrado',
            noShiftRegistered: 'Nenhum turno cadastrado',
            members: 'Membros',
            selectedNoneTitle: 'Nenhum Turno Selecionado',
            selectedNoneDescription:
              'Selecione um turno na lista ao lado ou clique no botão "+" para configurar novos horários de acesso.',
            weeklyScheduleTitle: 'Programação Semanal',
            clearSchedules: 'Limpar horários',
            tipsTitle: 'Dicas de configuração do sistema',
            tips: {
              directionByNameTitle: 'Direção pelo Nome:',
              directionByNameBody:
                'Ter "ENTRADA" ou "SAÍDA" no nome do equipamento define sua direção automaticamente. Valide isso na sua lista de dispositivos.',
              directionMatchTitle: 'Correspondência de Direção:',
              directionMatchBody:
                'A direção do horário deve coincidir com a da catraca. Um turno restrito para [ Entrada ] não libera o acesso em catracas de Saída.',
              bidirectionalTitle: 'Horário Bidirecional:',
              bidirectionalBody:
                'Deixar os botões de Entrada e Saída desmarcados libera a passagem em ambos os sentidos (ex: refeitórios).',
              midnightTitle: 'Madrugadas (22h às 06h):',
              midnightBody:
                'Se o turno cruza a meia-noite, divida-o: 22:00 às 23:59 no dia atual e 00:00 às 06:00 no dia seguinte.',
              deviceListLink: 'lista de dispositivos',
            },
            newShiftDefaultName: 'Novo Turno',
            saveNew: 'CADASTRAR NOVO TURNO',
            saveEdit: 'SALVAR ALTERAÇÕES',
            nameLabel: 'Nome do Turno *',
            devicesLabel: 'Dispositivos *',
            startLabel: 'Início',
            endLabel: 'Término',
            enter: 'Entrada',
            exit: 'Saída',
            addTimeSlot: 'Adicionar Horário',
            copyToWeekdays: 'Copiar para Seg-Sex',
            confirmClearTitle: 'Confirmar Limpeza',
            confirmClearQuestion:
              'Tem certeza que deseja apagar os horários de todos os dias da semana?',
            confirmClearDescription:
              'A programação atual será apagada e os dias desmarcados, permitindo que você recomece do zero.',
            cancel: 'Cancelar',
            clearAll: 'Sim, limpar tudo',
            deleteTitle: 'Excluir Turno de Acesso',
            deleteQuestion:
              'Tem certeza que deseja excluir o turno "{{name}}"?',
            deleteImpactTitle: 'Impacto da exclusão:',
            deleteImpactDescription:
              'Esta ação deixará {{count}} alunos sem turno de acesso configurado. As seguintes turmas serão afetadas:',
            deleteHide: 'Ocultar',
            deleteShowMore: '+ ver mais {{count}} turma(s)',
            irreversible: 'Esta ação é irreversível.',
            deleting: 'Excluindo...',
            confirmDelete: 'Confirmar',
            days: {
              monday: 'Segunda-feira',
              tuesday: 'Terça-feira',
              wednesday: 'Quarta-feira',
              thursday: 'Quinta-feira',
              friday: 'Sexta-feira',
              saturday: 'Sábado',
              sunday: 'Domingo',
            },
          },
          notificationLogs: {
            title: 'Logs de Notificações',
            description: 'Auditoria de envio de notificações.',
            filters: {
              button: 'Filtros',
              period: 'Período Específico',
              startDate: 'Data Inicial',
              endDate: 'Data Final',
              platforms: 'Plataformas',
              status: 'Status',
              success: 'Sucesso',
              failure: 'Falha',
              apply: 'Aplicar Filtros',
              clear: 'Limpar Filtros',
              invalidDateRange: 'A data inicial não pode ser maior que a final.',
            },
            quickFilters: {
              today: 'Hoje',
              last7Days: 'Últimos 7 dias',
              all: 'Todo o Período',
            },
            actions: {
              refresh: 'Atualizar',
              viewDetails: 'Ver detalhes',
              hideDetails: 'Ocultar detalhes',
            },
            table: {
              dateTime: 'DATA/HORA',
              platform: 'PLATAFORMA',
              status: 'STATUS',
              subject: 'SUJEITO',
              details: 'DETALHES',
              noData: 'Nenhum log encontrado com os filtros atuais.',
            },
            status: {
              success: 'SUCESSO',
              failure: 'FALHA',
            },
            details: {
              faceRecognitionEventId: 'FaceRecognitionEventId',
              recipients: 'Destinatários',
              subjectType: 'Tipo do sujeito',
              errorMessage: 'Mensagem de erro',
            },
            pagination: {
              rowsPerPage: 'Quantidade por página:',
              displayedRows: '{{from}}-{{to}} de {{count}}',
              displayedRowsMoreThan: '{{from}}-{{to}} de mais de {{to}}',
            },
          },
        },
      },
      es: {
        translation: {
          common: {
            devices: 'DISPOSITIVOS',
            device: 'Dispositivo',
            events: 'EVENTOS',
            client: 'Cliente',
            students: 'Estudiantes',
            parents: 'Padres',
            IVS: 'IVS',
            LPR: 'LPR',
            description: 'Descripción',
            date: 'Fecha',
            time: 'Hora',
            plate: 'Placa',
            name: 'Nombre',
            lastEvent: 'Último evento',
            image: 'Imagen',
            speed: 'Velocidad',
            plateImage: 'Imagen de la Placa',
            carImage: 'Imagen del Auto',
            student: 'Estudiante',
            responsible: 'Responsable',
            face: 'Rostro',
            recording: 'Grabación',
            gender: 'Género',
            recognitionImage: 'Imagen Reconocida',
            actions: 'Acciones',
            noItemsFound: 'No se encontraron elementos',
            model: 'Modelo',
            brand: 'Marca',
            type: 'Tipo',
            active: 'Ativo',
            edit: 'Editar',
            delete: 'Eliminar',
            unknown: 'Desconocido',
            none: 'No tiene',
            notApplicable: 'No aplica',
            notAvailable: 'No Posee',
            errorSaving: 'Error al guardar',
            errorLoadingData: 'Error al cargar datos',
            networkError:
              'Sin conexión a internet. Verifique su red e inténtelo de nuevo.',
            internalServerError: 'Error interno del servidor!',
            databaseUnavailable: 'El servicio de base de datos local no está disponible.',
            maxFileSizeError: 'El tamaño máximo permitido para la imagen es de 275 KB.',
          },
          dashboard: {
            welcome: 'Bienvenido a AlertAi',
            description:
              'Aquí encontrarás los principales indicadores de la plataforma en tiempo real. Navega por los gráficos e informes para seguir el rendimiento y los eventos registrados.',
            title: 'Dashboard',
            list: 'Lista',
            defense: 'Defense',
            monitoring: 'Monitoreo',
            settings: 'Configuraciones',
            accountSummary: 'Resumen de la cuenta',
            registeredDevices: 'Dispositivos registrados',
            activeDevices: 'Dispositivos ativos',
            faces: 'Rostros gerais',
            registeredEvents: 'Eventos registrados',
            notifications: 'Notificaciones',
          },
          map: {
            locations: 'Ubicaciones',
            showAll: "Mostrar todos",
            showSelected: "Mostrar solo seleccionado",
            openList: "Abrir lista de ubicaciones",
            closeList: "Cerrar lista de ubicaciones",
            stopFollow: "Dejar de seguir",
            vehicle: 'Vehículo',
            latitude: 'Latitud',
            longitude: 'Longitud',
            date: 'Fecha/Hora',
            plate: 'Placa',
            address: 'Dirección',
            openCamera: 'Abrir cámaras',
            closeCamera: 'Cerrar cámaras',
            updateTransmission: 'Actualizar transmisiones',
            loadingStreams: 'Cargando transmisiones...',
            noCamerasAvailable: 'No hay cámaras disponibles en este momento...',
            cameraCollapsed: 'Visualización de cámaras colapsada.',
            liveCameras: 'Cámaras en vivo',
            searchingAddress: 'Buscando dirección...',
            virtualFence: 'Cerca Virtual',
            virtualFenceDescription: 'Recibe alertas cuando un vehículo entra o sale del área definida.',
            status: 'Estado',
            statusMonitoring: 'Monitoreando',
            statusDisabled: 'Desactivada',
            notificationsEnabled: 'Notificaciones habilitadas',
            notificationPermissionDisabled: 'Permiso de notificaciones deshabilitado',
            selectOrAddFence: 'Seleccione o agregue una cerca para editar.',
            fenceName: 'Nombre de la cerca',
            addressOrZipCode: 'Dirección o Código Postal',
            searchAddressCenter: 'Buscar centro de dirección',
            pickAddressCenter: 'Definir centro en el mapa',
            pickingAddress: 'Haga clic en el mapa para marcar el centro',
            radiusMeters: 'Radio en metros',
            empty: 'Ningún punto definido',
            centerMarked: 'Centro marcado',
            centerEmpty: 'Centro vacío',
            geofenceActive: 'Cerca virtual activa',
            geofenceInactive: 'Cerca virtual inactiva',
            clearCenter: 'Limpiar centro',
            enteredFence: 'ENTRÓ en la cerca',
            leftFence: 'SALIÓ de la cerca',
            fenceListDescription: 'Abra, ajuste y monitoree entradas/salidas.',
            closeVirtualFence: 'Cerrar cerca virtual',
            openVirtualFence: 'Abrir cerca virtual',
            delete: 'Eliminar',
            cancel: 'Cancelar',
            confirmDeleteFenceTitle: 'Confirmar eliminación de la cerca virtual',
            confirmDeleteFence: '¿Está seguro de que desea eliminar "{{name}}"?',
            createFenceFailed: 'Error al crear la cerca virtual',
            updateFenceFailed: 'Error al actualizar la cerca virtual',
            deleteFenceFailed: 'Error al eliminar la cerca virtual',
            fenceCenterDefined: 'Centro de la cerca virtual definido',
            fenceCenterNotFound: 'Dirección o Código Postal no encontrado',
            fence: 'Cerca {{index}}',
            fenceCenterAddressDefined: 'Centro definido por dirección/Código Postal',
            fenceCenterSetTo: 'Centro definido para "{{description}}"',
          },
          financial: {
            licenses: 'Licencias',
            plan: 'Plan',
            usersAmount: 'Usuarios',
            devicesAmount: 'Dispositivos',
            search: 'Buscar Licencia',
            studentsAmount: 'Estudiantes',
            responsiblesAmount: 'Responsables',
            updatedAt: 'Actualizado en',
            studentUnitValue: 'Valor por Estudiante',
            totalValue: 'Valor Total',
          },
          monitoring: {
            Facial: 'Facial',
            Responsible: 'Responsable',
            Student: 'Estudiante',
            dontHaveEvents: 'No hay ningún evento.',
            eventsIVS: 'Eventos IVS',
            eventsLPR: 'Eventos LPR',
            eventsFacial: 'Eventos Faciales',
          },
          monitoringPage: {
            selectDevice: 'Seleccionar dispositivo',
            status: 'Estado',
            online: 'En línea',
            offline: 'Sin conexión',
            loadingDevices: 'Cargando dispositivos...',
            selectDeviceHint: 'Seleccione un dispositivo para ver el video.',
            selected: 'Seleccionados',
            deviceOffline: 'Dispositivo sin conexión',
          },
          deviceGroupPage: {
            title: 'Grupos de dispositivos',
            hint: 'Cree grupos para organizar dispositivos.',
            empty: 'No hay grupos registrados.',
            new: 'Nuevo grupo',
            devices: 'Dispositivos del grupo',
            devicesInGroup: 'Dispositivos en el grupo',
            editGroupTitle: 'Editar grupo de dispositivos',
            newGroupTitle: 'Nuevo grupo de dispositivos',
            groupName: 'Nombre del grupo',
            save: 'Guardar',
            confirmDelete: '¿Desea realmente eliminar este grupo?',
            lock: 'Bloquear',
            unlock: 'Desbloquear',
            locked: 'Bloqueado',
            unlocked: 'Desbloqueado',
            refresh: 'Atualizar',
            open: 'Abrir',
          },

          schoolMonitoring: {
            recording: 'Grabación',
            noResponsiblesAttached: 'No hay responsables vinculados a este estudiante',
            noStudentsAttached: 'No hay estudiantes pertenecientes a este responsable',
            videoNotFound: 'URL del vídeo no encontrada.',
            errorDownloading: 'Error al procesar la solicitud del vídeo.',
            errorPlayingVideo: 'No fue posible reproducir este vídeo.',
          },
          pauseButtonComponent: {
            startUpdates: 'Iniciar Atualizações',
            pauseUpdates: 'Pausar Atualizações',
          },
          customerMonitoring: {
            birthday: 'Cumpleaños',
          },
          actionsOptions: {
            configuration: 'Configuración',
            viewEvents: 'Ver Eventos',
            viewRecording: 'Ver Video',
            edit: 'Editar',
            delete: 'Eliminar',
          },
          actionButtonComponent: {
            edit: 'Editar',
            delete: 'Eliminar',
          },
          tableComponent: {
            searchHere: 'Buscar aquí',
            search: 'Buscar',
          },
          camsPage: {
            title: 'Cámaras',
            addCam: 'Agregar Cámara',
            manageGroups: 'Administrar Grupos',
          },
          controllersPage: {
            title: 'Controladores',
            addController: 'Nuevo Controlador',
          },
          routersNames: {
            dashboard: 'Panel de Control',
            proposalPdf: 'Propuesta PDF',
            serversPage: 'Servidores',
            monitoring: 'Monitoreo',
            geral: 'General',
            porter: 'Portaria',
            schoolMonitoring: 'Monitoreo Escolar',
            perimeterSchool: 'Perímetro Escolar',
            customerMonitoring: 'Clientes',
            devices: 'Dispositivos',
            cams: 'Cámaras',
            controllers: 'Controladores',
            centralAlarms: 'Centrales de Alarma',
            registerFaces: 'Rostros',
            sports: 'Deportes',
            integrationsPage: 'Integraciones',
            configuration: 'Configuración',
            communicationPage: 'Comunicación',
            remoteTax: 'Inspector Remoto',
            report: 'Informes',
            trans: 'Transporte',
            turn: 'Turno Escolar',
            ticket: 'Ticket Escolar',
            defense: 'DefenseIA',
            management: 'Gestión',
            class: 'Clases',
            logout: 'Salir',
            licenses: 'Licenças',
            notificationLogs: 'Registros de Notificaciones',
            location: 'Ubicación',
          },
          alarmCentral: {
            physical: 'Física',
            virtual: 'Virtual',
            editionTitle: 'Edición de la central',
            type: 'Tipo de Central',
            macAddress: 'Dirección MAC',
            password: 'Contraseña',
            account: 'Cuenta',
            partitionable: 'Central Particionada',
            event: 'Evento',
            zoneUser: 'Zona/Usuario',
            partition: 'Partición',
            occurredAt: 'Ocurrió en',
            newCentral: 'Nueva central',
            title: 'Centrales de alarma',
            tabCentrals: 'Centrales',
            tabEvents: 'Eventos',
            deleteTitle: 'Eliminar central de alarma',
            deleteMessage:
              '¿Está seguro de que desea eliminar la central de alarma "{{name}}"?',
          },
          recognitionPage: {
            title: 'Rostros',
            cleanFilters: 'Limpiar Filtros',
            synchronization: 'Sincronización',
            newFace: 'Nuevo Rostro',
            deleteFace: 'Eliminar Rostro',
            areYouSureWantToDeleteFace:
              '¿Está seguro de que desea eliminar este rostro?',
            recognitionImage: 'Imagen de la cara',
            tableHeaders: {
              type: 'Tipo',
              name: 'Nombre',
              CPF: 'CPF',
              CNPJ: 'CNPJ',
              image: 'Imagen',
              actions: 'Acciones',
            },
            registerFace: {
              general: 'General',
              student: 'Estudiante',
              responsible: 'Responsable',
              customer: 'Cliente',
              youForgotToTakeAPicture:
                '¡Vaya! Parece que olvidaste registrar la imagen del rostro.',
              updatedFace: '¡Rostro actualizado con éxito!',
              registerFace: '¡Rostro registrado con éxito!',
              updatingFace: 'Rostro siendo actualizado...',
              registeringFace: 'Rostro siendo registrado...',
            },
            modalEditFace: {
              title: 'Edición de Rostro',
              editFace: 'Editar Rostro',
              registerFace: 'Registrar Rostro',
              name: 'Nombre',
              cpf: 'CPF',
              cnpj: 'CNPJ',
              age: 'Edad',
              email: 'Email',
              faceValidity: 'Validez del Rostro',
              type: 'Tipo',
              occupation: 'Ocupación',
              birthdayDate: 'Fecha de Nacimiento',
              employee: 'Empleado',
              genders: {
                gender: 'Género',
                male: 'Masculino',
                female: 'Femenino',
                other: 'Otro',
              },
              serviceProvider: 'Proveedor de Servicios',
              visitor: 'Visitante',
              faceGroup: 'Grupo de Rostros',
              deviceGroup: "Grupo de dispositivos",
              facialController: 'Controlador Facial',
              shift: 'Turno',
              corporateUnity: 'UC (Unidad Corporativa)',
              cellPhone: 'Teléfono Celular',
              addAddress: 'Agregar dirección (opcional)',
              registration: 'Registro',
              dateOfBirth: 'Fecha de Nacimiento',
              cantLeave: 'No puedo irme?',
              schoolTransport: 'Transporte Escolar',
              responsible: 'Responsable',
              editPassword: 'Editar contraseña',
              repeatPassword: 'Repetir contraseña',
              temporaryStudents: 'Estudiantes Temporales',
              recognitionFilter: 'Filtro de Reconocimiento',
              filter: 'Filtrar',
              filterAll: 'Todos',
              filterTemporary: 'Temporal',
              plateVehicle: 'Placa del Vehículo',
              vehicleTags: 'Tag del Vehículo',
              accessCardTags: 'Tarjeta/Tag de Acceso',
              carPlates: 'Placa del Vehículo',
              status: 'Estado',
              filterActive: 'Activos',
              filterDesabled: undefined,
              filterDisabled: 'Desactivados',
              filterCondition: 'Condición',
              address: {
                address: 'Dirección',
                postalCode: 'Código Postal',
                country: 'País',
                state: 'Estado',
                city: 'Ciudad',
                neighborhood: 'Vecindario',
                street: 'Calle',
                addrNumber: 'Número',
                complement: 'Complementar',
              },
              buttonCaptureImage: {
                captureAgain: 'Capturar Nuevamente',
                save: 'Guardar',
                captureImageFace: 'Capturar Imagen del Rostro',
                changeFaceImage: 'Modificar Imagen del Rostro',
              },
              typesOfResponsible: {
                faceType: 'Tipo de Rostro',
                general: 'General',
                student: 'Estudiante',
                customer: 'Cliente',
                responsible: 'Responsable',
                faceTypeNotFound: 'Tipo de rostro no encontrado',
                unsupportedFaceType: 'Tipo de rostro no compatible',
              },
            },
            syncFacesModal: {
              title: 'Sincronización de Rostros',
              registeredInAlertAI: 'Registrado en AlertAI',
              noRegisteredInAlertAI: 'No registrado en AlertAI',
              deleteController: 'Eliminar controlador',
              fillInMissingData: 'Rellenar datos faltantes',
              noRegisterFaces: 'Ningún rostro registrado en el controlador.',
              facesFoundOnController: 'Caras encontradas en el controlador',
            },
          },
          sportsPage: {
            sportsFacilities: 'Unidades Deportivas',
            sportsCourts: 'Canchas Deportivas',
            newUnity: 'Nueva Unidad',
            unities: {
              name: 'Nombre',
              state: 'Estado',
              city: 'Ciudad',
              actions: 'Acciones',
              sportUnityModal: {
                addTitle: 'Agregar Unidad Deportiva',
                editTitle: 'Editar Unidad Deportiva',
                name: 'Nombre',
                address: 'Dirección',
                state: 'Estado',
                city: 'Ciudad',
                country: 'País',
                postalCode: 'Código Postal',
                neighborhood: 'Barrio',
                street: 'Calle',
                number: 'Número',
                complement: 'Complementar',
                saveButton: 'Guardar',
              },
            },
            blocks: {
              title: 'Bloques Deportivos',
              newBlock: 'Nueva Cancha',
              name: 'Nombre',
              unity: 'Unidad',
              actions: 'Acciones',
              save: 'Guardar',
              sportBlockModal: {
                addTitle: 'Agregar Cancha Deportivo',
                editTitle: 'Editar Cancha Deportivo',
                name: 'Nombre',
                unitySports: 'Unidad Deportiva',
                saveButton: 'Guardar',
                devices: 'Dispositivos',
                playbackTime: 'Tiempo de Reproducción',
                advertising: 'Publicidad',
                playbackTimeOptions: {
                  option1: '20 segundos',
                  option2: '30 segundos',
                  option3: '40 segundos',
                },
              },
              sportsCourtSuccessUpdate:
                '¡Cancha Deportiva actualizada con éxito!',
              sportsCourtSuccessCreate: '¡Cancha Deportiva creada con éxito!',
              imagemUploaderComponent: {
                dropImageHereOrClickToUpload:
                  'Suelta la imagen aquí o haz clic para subirla',
                requiredField: 'Campo obligatorio',
                invalidImageDimensions: 'Dimensiones de imagen inválidas',
              },
            },
          },
          integrationsPage: {
            title: 'Integraciones',
            newIntegration: 'Nueva Integración',
            editIntegration: 'Editar Integración',
            typeIntegration: 'Tipo de Integración',
            tableColumns: {
              type: 'Tipo',
              name: 'Nombre',
              description: 'Descripción',
              actions: 'Acciones',
            },
            cigamForms: {
              name: 'Nombre',
              host: 'Host',
              door: 'Puerto',
              user: 'Usuario',
              password: 'Contraseña',
              descriptors: 'Descripción',
              active: 'Activo',
            },
            defenseForms: {
              name: 'Nombre',
              username: 'Nombre de Usuario',
              ipServer: 'Ip del Servidor',
              mqttDoorServer: 'Puerto MQTT del Servidor',
              userType: 'Tipo de Usuario',
              password: 'Contraseña',
              httpDoorServer: 'Puerto HTTP del Servidor',
              description: 'Descripción',
              status: 'Estado',
              save: 'Guardar',
            },
            moniForms: {
              name: 'Nombre',
              door: 'Puerto',
              password: 'Contraseña',
              enterprise: 'Empresa',
              ip: 'IP',
              user: 'Usuario',
              jointOccurrenceCode: 'Código conjunto de ocurrencias',
              description: 'Descripción',
              active: 'Activo',
              save: 'Guardar',
            },
            sigmaForms: {
              name: 'Nombre',
              accountsReceivableEvents: 'Eventos de Cuentas por Cobrar',
              token: 'Token',
              description: 'Descripción',
              active: 'Activo',
              save: 'Guardar',
            },
            surgardForms: {
              typeConnection: 'Tipo de Conexión',
              door: 'Puerto',
              description: 'Descripción',
              name: 'Nombre',
              intervalKeepAlive: 'Intervalo Keep Alive (En segundos)',
              waitACK: 'Esperar ACK',
              active: 'Activo',
              save: 'Guardar',
            },
            webHookForms: {
              name: 'Nombre',
              url: 'URL',
              token: 'Token',
              password: 'Contraseña',
              description: 'Descripción',
              user: 'Usuario',
              bodyRequisition: 'Cuerpo de la Requisición',
              active: 'Activo',
              save: 'Guardar',
            },
            defenseBridgeForms: {
              name: 'Nombre',
              ipServer: 'IP del Servidor',
              doorServer: 'Puerto del Servidor',
              description: 'Descripción',
              accessKey: 'Clave de Acceso',
              secretKey: 'Clave Secreta',
              status: 'Estado',
              save: 'Guardar',
            },
            totvsForms: {
              name: 'Nombre',
              domain: 'Dominio',
              user: 'Usuario',
              password: 'Contraseña',
              description: 'Descripción',
              active: 'Activo',
              save: 'Guardar',
            },
            tuyaForms: {
              name: 'Nombre',
              description: 'Descripción',
              idUserTuya: 'ID de Usuario Tuya',
              status: 'Estado',
              save: 'Guardar',
            },
            smtpForms: {
              host: 'Host',
              port: 'Puerto',
              enableSsl: 'Habilitar SSL',
              username: 'Nombre de Usuario',
              password: 'Contraseña',
              description: 'Descripción',
              isActive: 'Activo',
              fromAddress: 'Correo electrónico del Remitente',
              save: 'Guardar',
              name: 'Nombre',
            },
            moovsecForms: {
              name: 'Nombre',
              baseUrl: 'URL Base',
              login: 'Usuario',
              password: 'Contraseña',
              description: 'Descripción',
              isActive: 'Activo',
              save: 'Guardar',
            }
          },
          defensePage: {
            deviceTable: {
              title: 'Dispositivos DefenseIA',
              synchronize: 'Sincronizar',
              columnTables: {
                status: 'Status',
                name: 'Nombre',
                model: 'Modelo',
                brand: 'Marca',
                defenseID: 'ID Defense',
                actions: 'Acciones',
              },
              detailsDefenseDeviceModal: {
                title: 'Detalhes do Dispositivo',
                name: 'Nome',
                model: 'Modelo',
                brand: 'Marca',
                category: 'Categoria',
                status: 'Status',
                idDefense: 'ID Defense',
                type: 'Tipo',
                ip: 'IP',
                protocol: 'Protocolo',
              },
            },
          },
          configurationPage: {
            users: {
              title: 'Usuarios registrados',
              newUser: 'Nuevo usuario',
              name: 'Nombre',
              email: 'Correo electrónico',
              positions: 'Cargos',
              action: 'Acciones',
            },
          },
          schoolShiftPage: {
            title: 'Turnos de Acceso',
            searchPlaceholder: 'Buscar turno...',
            clearSearch: 'Limpiar búsqueda',
            newShift: 'Registrar nuevo turno',
            noShiftFound: 'Ningún turno encontrado',
            noShiftRegistered: 'Ningún turno registrado',
            members: 'Miembros',
            selectedNoneTitle: 'Ningún Turno Seleccionado',
            selectedNoneDescription: 'Seleccione un turno en la lista de al lado o haga clic en el botón "+" para configurar nuevos horarios de acceso.',
            weeklyScheduleTitle: 'Programación Semanal',
            clearSchedules: 'Limpiar horarios',
            tipsTitle: 'Consejos de configuración del sistema',
            tips: {
              directionByNameTitle: 'Dirección por Nombre:',
              directionByNameBody: 'Tener "ENTRADA" o "SALIDA" en el nombre del equipo define su dirección automáticamente. Valide esto en su lista de dispositivos.',
              directionMatchTitle: 'Correspondencia de Dirección:',
              directionMatchBody: 'La dirección del horario debe coincidir con la del torniquete. Un turno restringido para [ Entrada ] no libera el acceso en torniquetes de Salida.',
              bidirectionalTitle: 'Horario Bidireccional:',
              bidirectionalBody: 'Dejar los botones de Entrada y Salida desmarcados libera el paso en ambos sentidos (ej: comedores).',
              midnightTitle: 'Madrugadas (22h a 06h):',
              midnightBody: 'Si el turno cruza la medianoche, divídalo: 22:00 a 23:59 en el día actual y 00:00 a 06:00 al día siguiente.',
              deviceListLink: 'lista de dispositivos',
            },
            newShiftDefaultName: 'Nuevo Turno',
            saveNew: 'REGISTRAR NUEVO TURNO',
            saveEdit: 'GUARDAR CAMBIOS',
            nameLabel: 'Nombre del Turno *',
            devicesLabel: 'Dispositivos *',
            startLabel: 'Inicio',
            endLabel: 'Fin',
            enter: 'Entrada',
            exit: 'Salida',
            addTimeSlot: 'Agregar Horario',
            copyToWeekdays: 'Copiar a Lun-Vie',
            confirmClearTitle: 'Confirmar Limpieza',
            confirmClearQuestion: '¿Está seguro de que desea borrar los horarios de todos los días de la semana?',
            confirmClearDescription: 'La programación actual se borrará y los días se desmarcarán, permitiéndole empezar desde cero.',
            cancel: 'Cancelar',
            clearAll: 'Sí, limpiar todo',
            deleteTitle: 'Eliminar Turno de Acceso',
            deleteQuestion: '¿Está seguro de que desea eliminar el turno "{{name}}"?',
            deleteImpactTitle: 'Impacto de la eliminación:',
            deleteImpactDescription: 'Esta acción dejará a {{count}} estudiantes sin turno de acceso configurado. Las siguientes clases se verán afectadas:',
            deleteHide: 'Ocultar',
            deleteShowMore: '+ ver más {{count}} clase(s)',
            irreversible: 'Esta acción es irreversible.',
            deleting: 'Eliminando...',
            confirmDelete: 'Confirmar',
            days: {
              monday: 'Lunes',
              tuesday: 'Martes',
              wednesday: 'Miércoles',
              thursday: 'Jueves',
              friday: 'Viernes',
              saturday: 'Sábado',
              sunday: 'Domingo',
            },
          },
          notificationLogs: {
            title: 'Registros de Notificaciones',
            description: 'Auditoría del envío de notificaciones.',
            filters: {
              button: 'Filtros',
              period: 'Periodo específico',
              startDate: 'Fecha inicial',
              endDate: 'Fecha final',
              platforms: 'Plataformas',
              status: 'Estado',
              success: 'Éxito',
              failure: 'Fallo',
              apply: 'Aplicar filtros',
              clear: 'Limpiar filtros',
              invalidDateRange: 'La fecha inicial no puede ser mayor que la final.',
            },
            quickFilters: {
              today: 'Hoy',
              last7Days: 'Últimos 7 días',
              all: 'Todo el período',
            },
            actions: {
              refresh: 'Actualizar',
              viewDetails: 'Ver detalles',
              hideDetails: 'Ocultar detalles',
            },
            table: {
              dateTime: 'FECHA/HORA',
              platform: 'PLATAFORMA',
              status: 'ESTADO',
              subject: 'SUJETO',
              details: 'DETALLES',
              noData: 'Ningún registro encontrado con los filtros actuales.',
            },
            status: {
              success: 'ÉXITO',
              failure: 'FALLO',
            },
            details: {
              faceRecognitionEventId: 'FaceRecognitionEventId',
              recipients: 'Destinatarios',
              subjectType: 'Tipo de sujeto',
              errorMessage: 'Mensaje de error',
            },
            pagination: {
              rowsPerPage: 'Cantidad por página:',
              displayedRows: '{{from}}-{{to}} de {{count}}',
              displayedRowsMoreThan: '{{from}}-{{to}} de más de {{to}}',
            },
          },
        },
      },
    },
  });

export default i18n;
